import { Controller } from "@hotwired/stimulus"

// Controller for the tournament workflow stepper
// Handles tooltips and visual feedback
export default class extends Controller {
  static targets = ["step", "tooltip"]

  connect() {
    // Controller is ready
  }

  // Show tooltip on step hover (handled by CSS group-hover)
  // This controller can be extended for additional interactions

  // Animate to current step on page load
  highlightCurrent() {
    this.stepTargets.forEach((step, index) => {
      const isCurrent = step.querySelector('.animate-pulse')
      if (isCurrent) {
        step.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
      }
    })
  }
}
